import { useCallback, useContext } from 'react';
import { toggleDashboardFullScreen, toggleFullScreen } from '../../../../slices/ui';
import { useAppDispatch } from '../../../../store/hooks';
import { MapContext } from '../map';
import Context from './Context';

function Provider({ fitMap, children, toggleMarkerClusters }) {
  const { map } = useContext(MapContext);
  const dispatch = useAppDispatch();

  const toggleFullScreenCb = useCallback(() => {
    dispatch(toggleFullScreen());
    setTimeout(() => map.invalidateSize(), 50);
  }, [dispatch, map]);

  const toggleFullScreenDashboardCb = useCallback(() => {
    dispatch(toggleDashboardFullScreen());
    setTimeout(() => map.invalidateSize(), 50);
  }, [dispatch, map]);

  return (
    <Context.Provider
      value={{
        fitMap,
        toggleMarkerClusters,
        toggleFullScreen: toggleFullScreenCb,
        toggleFullScreenDashboard: toggleFullScreenDashboardCb,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export default Provider;
